import styled from 'styled-components'

interface ISheetContentStyledProps {}

export const SheetContentStyled = styled.div<ISheetContentStyledProps>`
  font-size: inherit;

  padding: ${(props) => props.theme.typography.pxToRem(8)};
`

SheetContentStyled.displayName = 'SheetContentStyled'
